var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mb-10 mx-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-4",
    style: _vm.partnerColor.gradientStyle
  }, [_c('v-text-field', {
    staticClass: "white",
    attrs: {
      "dense": "",
      "append-icon": "mdi-magnify",
      "label": _vm.$t('components.analytics.AnalyticsDataTableDialog.search'),
      "single-line": "",
      "hide-details": "",
      "solo": ""
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('v-spacer'), _c('v-btn', {
    staticClass: "d-none d-sm-block ml-2",
    attrs: {
      "dense": "",
      "small": "",
      "flat": "",
      "depressed": "",
      "color": _vm.partnerColor.primaryDarken_2,
      "dark": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          path: '/create-charging-station'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgVehicleTable.btnText")) + " ")])], 1), _c('v-divider'), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.myChargingStation,
      "search": _vm.search,
      "items-per-page": 10,
      "custom-filter": _vm.filterAll,
      "sort-by": "timestamp.created",
      "sort-desc": true,
      "show-expand": "",
      "single-expand": true
    },
    scopedSlots: _vm._u([{
      key: "item.timestamp.created",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(new Date(item.timestamp.created).toLocaleString()))])];
      }
    }, {
      key: "item.commissioningDate",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(new Date(item.commissioningDate).toLocaleString("de-DE", _vm.dateOptions)))])];
      }
    }, {
      key: "item.address",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', [_vm._v(_vm._s(item.address.street) + ", " + _vm._s(item.address.zip) + " " + _vm._s(item.address.city))])];
      }
    }, {
      key: "item.controls",
      fn: function fn(props) {
        return [_c('v-btn', {
          attrs: {
            "dense": "",
            "small": "",
            "flat": "",
            "depressed": "",
            "color": "info"
          },
          on: {
            "click": function click($event) {
              return _vm.goToAddMeterReading(props.item);
            }
          }
        }, [_vm._v(" Quote beantragen ")])];
      }
    }, {
      key: "expanded-item",
      fn: function fn(_ref4) {
        var headers = _ref4.headers,
            item = _ref4.item;
        return [_c('td', {
          staticClass: "pa-0",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "elevation-0",
          attrs: {
            "hide-default-footer": "",
            "headers": _vm.meterReadingHeaders,
            "items": _vm.meterReadingsByChargingStation(item)
          },
          scopedSlots: _vm._u([{
            key: "item.status",
            fn: function fn(_ref5) {
              var item = _ref5.item;
              return [_c('v-tooltip', {
                attrs: {
                  "bottom": ""
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function fn(_ref6) {
                    var on = _ref6.on,
                        attrs = _ref6.attrs;
                    return [_c('v-chip', {
                      attrs: {
                        "dark": "",
                        "color": _vm.thgStatus(item.status).color
                      }
                    }, [_c('v-icon', _vm._g(_vm._b({}, 'v-icon', attrs, false), on), [_vm._v(" " + _vm._s(_vm.thgStatus(item.status).icon) + " ")])], 1)];
                  }
                }], null, true)
              }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t(_vm.thgStatus(item.status).text)))])])];
            }
          }, {
            key: "item.meterReading.startDate",
            fn: function fn(_ref7) {
              var item = _ref7.item;
              return [_c('span', [_vm._v(_vm._s(new Date(item.meterReading.startDate).toLocaleString("de-DE", _vm.dateOptions)))])];
            }
          }, {
            key: "item.meterReading.endDate",
            fn: function fn(_ref8) {
              var item = _ref8.item;
              return [_c('span', [_vm._v(_vm._s(new Date(item.meterReading.endDate).toLocaleString("de-DE", _vm.dateOptions)))])];
            }
          }], null, true)
        })], 1)];
      }
    }, {
      key: "footer.prepend",
      fn: function fn() {
        return [_c('thg-vehicle-table-legend-dialog')];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.selection,
      callback: function callback($$v) {
        _vm.selection = $$v;
      },
      expression: "selection"
    }
  }, [_c('template', {
    slot: "no-data"
  }, [_c('latest-entries-card-empty', {
    staticClass: "ma-6"
  })], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }